'use strict';

const DIALOG_REGISTRY = require('../../dialogs/dialog.registry.js');

module.exports = (app) => app.directive('materialGroupSelection', /* @ngInject */ function () {
	return {
		restrict: 'E',
		scope: {
			value: '=?',
			initValue: '=?',
			inputId: '@?',
			inputName: '@?',
			customerCompanyId: '@?',
			showLabel: '=?',
			readonly: '=?',
			labelClass: '@?',
			inputClass: '@?',
		},
		templateUrl: `./${BUILD_PATH}/material-group-selection.directive.html`,
		controller: /* @ngInject */ function ($scope, dialogService, materialGroupService, aclService) {
			const DEFAULT_LABEL_CLASS = 'col-auto';
			const DEFAULT_INPUT_CLASS = 'col';

			$scope.loading = false;
			$scope.active = true;
			$scope.selectedMaterialGroup = null;
			$scope.selectedLabel = '';
			$scope.selectedName = '';
			$scope.resolvedInputId = null;
			$scope.resolvedInputName = null;

			$scope.openDialog = openDialog;
			$scope.clearSelection = clearSelection;

			init();

			function init() {
				if (typeof $scope.showLabel === 'undefined') {
					$scope.showLabel = true;
				}
				if (typeof $scope.readonly === 'undefined') {
					$scope.readonly = false;
				}
				if (!$scope.labelClass) {
					$scope.labelClass = DEFAULT_LABEL_CLASS;
				}
				if (!$scope.inputClass) {
					$scope.inputClass = DEFAULT_INPUT_CLASS;
				}

				$scope.resolvedInputName = $scope.inputName || $scope.inputId || 'materialGroup';
				$scope.resolvedInputId = $scope.inputId || $scope.resolvedInputName;

				loadSelectedValue(resolveCurrentValue());

				$scope.$watch('value', (newValue, oldValue) => {
					if (newValue === oldValue && typeof oldValue !== 'undefined') {
						return;
					}

					const selectedCode = $scope.selectedMaterialGroup?.code || null;
					if ((newValue || null) !== selectedCode) {
						loadSelectedValue(newValue);
					}
				});

				$scope.$watch('initValue', (newValue, oldValue) => {
					if (newValue === oldValue) {
						return;
					}

					if ($scope.value) {
						return;
					}

					const selectedCode = $scope.selectedMaterialGroup?.code || null;
					if ((newValue || null) !== selectedCode) {
						loadSelectedValue(newValue);
					}
				});

			}

			function openDialog() {
				if ($scope.readonly || $scope.loading) {
					return;
				}

				const dialogType = DIALOG_REGISTRY.MATERIAL_GROUP_SELECTION;
				const config = {
					title: 'Warengruppe auswählen',
					style: {
						height: '75vh',
						'max-height': '75vh',
						width: '80vw',
						'max-width': '80vw',
					},
				};

				dialogService.open(dialogType.templatePath, dialogType.id, { context: resolveContext() }, config).then((selectedEntry) => {
					if (selectedEntry) {
						setSelection(selectedEntry, true);
					}
					applySafe();
				});
			}

			function clearSelection() {
				if ($scope.readonly || $scope.loading) {
					return;
				}

				setSelection(null, true);
			}

			function loadSelectedValue(value) {
				if (!value) {
					setSelection(null, false);
					return;
				}

				$scope.loading = true;
				materialGroupService
					.getByCode(value, resolveContext())
					.then((materialGroup) => {
						setSelection(materialGroup, false);
					})
					.catch((error) => {
						console.error(error);
						setSelection(null, false);
					})
					.finally(() => {
						$scope.loading = false;
						applySafe();
					});
			}

			function setSelection(materialGroup, emit) {
				$scope.selectedMaterialGroup = materialGroup || null;
				$scope.selectedName = materialGroup?.name || '';
				$scope.selectedLabel = materialGroup?.label || materialGroup?.code || '';

				if (emit) {
					setExternalValue(materialGroup?.code || '');
				}
			}

			function setExternalValue(value) {
				try {
					$scope.value = value;
				} catch (error) {
					// Ignore non-assignable expressions and rely on hidden input value.
				}
			}

			function resolveCurrentValue() {
				return $scope.value || $scope.initValue || '';
			}

			function resolveContext() {
				return {
					customerCompanyId: normalizeValue($scope.customerCompanyId),
				};
			}

			function normalizeValue(value) {
				if (typeof value === 'undefined' || value === null) {
					return '';
				}

				return String(value).trim();
			}

			function applySafe() {
				if (!$scope.$$phase) {
					$scope.$apply();
				}
			}
		},
	};
});
